import React from 'react';

import CustomerInfo from './CustomerInfo';
import { GET_CUSTOMER } from '../graphql/queries';
import { useQuery } from '@apollo/client';
import useHandleAuthError from '../../../utils/hooks/useHandleAuthError';
import CustomerBookings from './CustomerBookings';
import QueryGuard from '../../../Components/QueryGuard';
import CustomerReview from './CustomerReview';
import CustomerTickets from './CustomerTickets';
import ContextMenu from '../../Requests/ContextMenu';
import CustomerGiftVouchers from './CustomerGiftVouchers/CustomerGiftVouchers';
import { useNavigate, useParams } from 'react-router-dom';
import { useUserDetails } from '../../../UserContext/UserContex';
import CustomerPackages from './CustomerPackages';
import { useCreatePackageMutation } from '../graphql/createPackage.generated';

const CustomerDetails = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const onError = useHandleAuthError();
  const { id: userId } = useUserDetails();

  const { loading, error, data } = useQuery(GET_CUSTOMER, {
    variables: { id },
    onError
  });

  const [createPackage] = useCreatePackageMutation({
    variables: {
      input: {
        customer: id || '',
        packageName: 'New package',
        createdBy: userId
      }
    },
    onCompleted: ({ createPackage }) => {
      navigate(`/packages/${createPackage?.id}/edit`);
    },
    onError: (error) => console.log({ error })
  });

  return (
    <QueryGuard error={!!error} loading={loading} data={data?.customer}>
      {data?.customer && id && (
        <div style={{ paddingBottom: '4rem' }}>
          <CustomerInfo customer={data.customer} hasBookings={!!data.customer.bookings.length} />
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <CustomerReview id={id} reviewed={data.customer.review} />
            <ContextMenu
              items={[
                { label: 'Create booking', onClick: () => navigate(`/bookings/new/${id}`) },
                { label: 'Create ticket', onClick: () => navigate(`/tickets/new/${id}`) },
                { label: 'Create gift voucher', onClick: () => navigate(`/gift-vouchers/new/${id}`) },
                { label: 'Create package', onClick: () => createPackage() }
              ]}
            />
          </div>
          <CustomerBookings bookingIds={data?.customer?.bookings} customerId={id} />
          <CustomerTickets customerId={id} />
          <CustomerGiftVouchers customerId={id} />
          <CustomerPackages customerId={id} />
        </div>
      )}
    </QueryGuard>
  );
};

export default CustomerDetails;
